// extracted by mini-css-extract-plugin
export default {"error":"Error__error___xnSGl","header":"Error__header___vRwbN","errorImage":"Error__errorImage___BaYF5","buttonLayout":"Error__buttonLayout___gTaXB","button":"Error__button___qmJMF"};